import React from 'react'
import FloCheckbox from '../common/form-elements/FloCheckbox'
import InputTextField from '../common/form-elements/InputTextField'
import CartNotesIcon from './sub-components/CartNotesIcon'
import { useCartContext } from 'src/lib/contexts/CartContext'
import { useLocale } from 'src/lib/hooks/useLocal'

const CartNotesSetup = () => {
  const {
    getters: { cartNotes, cartNoteErrors },
    actions: { setCartNotes, setCartNoteErrors }
  } = useCartContext()
  const { t } = useLocale()

  return (
    <div className='py-3 px-4 bg-white border border-gray-light rounded-xl flex flex-col gap-3'>
      <div className='flex items-center justify-between mb-1'>
        <h3 className='font-medium text-base text-carbon'>{t('notes')}</h3>
        <FloCheckbox
          value={cartNotes.enabled}
          type='SWITCH'
          setValue={(value: boolean) => setCartNotes({ ...cartNotes, enabled: value })}
        />
      </div>
      {cartNotes.enabled && (
        <div className='flex flex-col gap-3'>
          <InputTextField
            textFieldId='cart-notes'
            label='Title'
            handleChange={e => setCartNotes({ ...cartNotes, title: e.target.value })}
            inputValue={cartNotes.title}
            errorStatus={cartNoteErrors.title.hasError}
            errorMessage={cartNoteErrors.title.errorMessage}
            handleFocus={() => {
              setCartNoteErrors({ ...cartNoteErrors, title: { hasError: false, errorMessage: '' } })
            }}
            fixedCharacterLimit={30}
            customErrorMessage=''
            showCharacterCountConfig={{
              maxLength: 30,
              showOnlyOnFocus: false,
              showCharacterCountOnLabel: true
            }}
          />
          <InputTextField
            textFieldId='cart-notes-sugesstion'
            label='Sugesstion text'
            handleChange={e => setCartNotes({ ...cartNotes, suggestionText: e.target.value })}
            inputValue={cartNotes.suggestionText}
            errorStatus={cartNoteErrors.suggestionText.hasError}
            errorMessage={cartNoteErrors.suggestionText.errorMessage}
            handleFocus={() => {
              setCartNoteErrors({ ...cartNoteErrors, suggestionText: { hasError: false, errorMessage: '' } })
            }}
            showCharacterCountConfig={{
              maxLength: 60,
              showOnlyOnFocus: false,
              showCharacterCountOnLabel: true
            }}
            fixedCharacterLimit={60}
            customErrorMessage=''
          />
          <div>
            <h3 className='text-gray-dark text-[12px] font-medium'>{t('icon')}</h3>
            <div>
              <CartNotesIcon
                value={cartNotes.icon}
                onChange={value => {
                  setCartNotes({ ...cartNotes, icon: value })
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CartNotesSetup
